import { IObservable, mkObservable } from "./Observable";

export const map = <T, D>(project: (t: T) => D) => (source: IObservable<T>): IObservable<D> => mkObservable(observer => source.subscribe({
  next: x => observer.next(project(x)),
  error: err => observer.error(err),
  complete: () => observer.complete()
}));
